export default "__VITE_ASSET__DMq1XUgP__"